// H5用到的app方法列表
export const H5InteractionAppMethodNames = {
  //跳转 公司详情页面
  TO_APP_COMPANY_PAGE: "toAppCompanyPage",

  // 跳转 职位详情页面
  TO_APP_JOB_DETAIL_PAGE: "toAppJobDetailPage",

  // 跳转到某个页面
  TO_APP_SOME_PAGE: "toAppSomePage",

  // 跳着到简历模板搜索页面
  TO_APP_RESUME_PAGE: "toAppResumePage",
};

export const MEMBER_PRICE_DATA = {
  MONTH: 19.9,
  YEAR: 79.9,
  FOREVER: 99.9,
  WONDERPLUS: 119.9,
};
